// ELEMENTOR Trigger
(function($) {
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/cube-link-carousel.default', function ($scope) {
      const elementSelector = `[data-id="${$scope.data('id')}"] .link-carousel`;
      const swiperSettings = $(elementSelector).data('swiper'); // Get parameters from data-swiper attribute in HTML
      const swiper = new Swiper(elementSelector, swiperSettings);
    });
  });
})(jQuery);
